import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AdminAuthContextProvider } from './administrator/admin/AdminAuthContext';

import { GoogleOAuthProvider } from "@react-oauth/google";
import { UserAuthContextProvider } from "./user/UserAuthContext";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  
     <AdminAuthContextProvider>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <UserAuthContextProvider>
                 <App />
            </UserAuthContextProvider>
            </GoogleOAuthProvider>
     </AdminAuthContextProvider>
  </React.StrictMode>
);

